export default (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "GET_TASK_GROUPS":
      return { ...state, taskGroups: action.payload, error: null };
    case "GET_TASKS":
      return { ...state, tasks: action.payload, error: null };
    case "ADD_TASK_GROUP":
      return { ...state, taskGroups: [action.payload, ...state.taskGroups] };
    case "EDIT_TASK_GROUP":
      return {
        ...state,
        taskGroups: state.taskGroups.map((group) =>
          group._id === action.payload._id ? action.payload : group
        ),
      };
    case "DELETE_TASK_GROUP":
      return {
        ...state,
        taskGroups: state.taskGroups.filter((group) => group._id !== action.payload),
      };
    case "ADD_TASK":
      return { ...state, tasks: [action.payload, ...state.tasks] };
    case "EDIT_TASK":
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task._id === action.payload._id ? action.payload : task
        ),
      };
    case "DELETE_TASK":
      return {
        ...state,
        tasks: state.tasks.filter((task) => task._id !== action.payload),
      };
    default:
      return state;
  }
};
